import React from "react";

export const CheckIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00798 8.39083L12.3887 4.01016C12.5267 3.87216 12.7186 3.8015 12.9133 3.8175C13.108 3.83283 13.286 3.93283 13.4007 4.0915C13.4007 4.0915 13.4173 4.1155 13.4187 4.11683C14.204 5.21083 14.6673 6.5515 14.6673 8.00016C14.6673 11.6795 11.68 14.6668 8.00065 14.6668C4.32132 14.6668 1.33398 11.6795 1.33398 8.00016C1.33398 4.32083 4.32132 1.3335 8.00065 1.3335C9.06465 1.3335 10.0713 1.5835 10.964 2.02816C11.294 2.1915 11.428 2.59216 11.264 2.9215C11.1 3.25083 10.7 3.3855 10.3707 3.2215C9.65665 2.86616 8.85132 2.66683 8.00065 2.66683C5.05732 2.66683 2.66732 5.05683 2.66732 8.00016C2.66732 10.9435 5.05732 13.3335 8.00065 13.3335C10.944 13.3335 13.334 10.9435 13.334 8.00016C13.334 7.11616 13.1187 6.2815 12.7367 5.5475L8.47998 9.80483C8.21932 10.0655 7.79732 10.0655 7.53665 9.80483L5.53665 7.80483C5.27665 7.54483 5.27665 7.12216 5.53665 6.86216C5.79732 6.60216 6.21932 6.60216 6.47998 6.86216L8.00798 8.39083Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.362357 13.7928C-0.117521 14.2727 -0.127314 15.1247 0.37215 15.6242C0.881408 16.1236 1.73344 16.1138 2.20352 15.6438L8.00122 9.84606L13.7891 15.634C14.2788 16.1236 15.121 16.1236 15.6205 15.6242C16.12 15.1149 16.12 14.2825 15.6303 13.7928L9.84239 8.0049L15.6303 2.2072C16.12 1.71753 16.1298 0.875295 15.6205 0.375831C15.121 -0.123633 14.2788 -0.123633 13.7891 0.366038L8.00122 6.15394L2.20352 0.366038C1.73344 -0.113839 0.871614 -0.133426 0.37215 0.375831C-0.127314 0.875295 -0.117521 1.73711 0.362357 2.2072L6.15027 8.0049L0.362357 13.7928Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 11H13V5C13 4.73478 12.8946 4.48043 12.7071 4.29289C12.5196 4.10536 12.2652 4 12 4C11.7348 4 11.4804 4.10536 11.2929 4.29289C11.1054 4.48043 11 4.73478 11 5V11H5C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13H11V19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19V13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MinusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2793 11.04C19.4395 11.0866 19.5869 11.1729 19.707 11.293C19.8946 11.4805 20 11.7348 20 12C20 12.2652 19.8946 12.5195 19.707 12.707C19.587 12.8271 19.4395 12.9134 19.2793 12.96H4.7207C4.56052 12.9134 4.41305 12.8271 4.29297 12.707C4.10544 12.5195 4 12.2652 4 12C4.00001 11.7348 4.10544 11.4805 4.29297 11.293C4.41305 11.1729 4.56052 11.0866 4.7207 11.04H19.2793Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const NavArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4805 5.56002L13.8405 21.22C13.7405 21.5 13.3405 21.48 13.2605 21.2L11.0005 13.86C10.9805 13.76 10.9005 13.68 10.8005 13.66L3.4605 11.4C3.1805 11.32 3.1605 10.92 3.4405 10.82L19.1005 5.18002C19.3405 5.08002 19.5805 5.32002 19.4805 5.56002Z"
        fill="#262626"
      />
      <path
        d="M3.45999 11.4002L10.8 13.6602C10.84 13.6802 10.9 13.7002 10.92 13.7402L19.4 5.26024C19.32 5.18024 19.2 5.14024 19.08 5.18024L3.43999 10.8202C3.15999 10.9202 3.15999 11.3202 3.45999 11.4002Z"
        fill="#434343"
      />
    </svg>
  );
};

export const YaMapsIcon = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C3.58163 0 0 3.58156 0 7.99986C0 10.2083 0.895223 12.2081 2.34202 13.6556C3.78955 15.1038 7.20007 17.1996 7.40006 19.4001C7.43038 19.73 7.66935 20 8 20C8.33138 20 8.57034 19.73 8.60067 19.4001C8.80065 17.1996 12.2105 15.1038 13.658 13.6556C15.1055 12.2081 16 10.2083 16 7.99986C16 3.58156 12.4184 0 8 0Z"
        fill="#FF4433"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.02239 10.8307C9.57315 10.8307 10.83 9.57311 10.83 8.02307C10.83 6.47231 9.57315 5.21477 8.02239 5.21477C6.47163 5.21477 5.21481 6.47231 5.21481 8.02307C5.21481 9.57311 6.47163 10.8307 8.02239 10.8307Z"
        fill="white"
      />
    </svg>
  );
};

export const SettingsIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0831 11.0505C16.9495 10.8984 16.8758 10.7029 16.8758 10.5005C16.8758 10.2981 16.9495 10.1026 17.0831 9.95048L18.1498 8.75048C18.2673 8.61937 18.3403 8.4544 18.3582 8.27924C18.3762 8.10407 18.3382 7.92772 18.2498 7.77548L16.5831 4.89215C16.4955 4.74008 16.3622 4.61955 16.202 4.54772C16.0419 4.4759 15.8632 4.45645 15.6914 4.49215L14.1248 4.80882C13.9254 4.85001 13.7179 4.81681 13.5413 4.71548C13.3648 4.61416 13.2314 4.45172 13.1664 4.25882L12.6581 2.73382C12.6022 2.5683 12.4957 2.42454 12.3536 2.32285C12.2115 2.22116 12.0411 2.1667 11.8664 2.16715H8.53308C8.35136 2.15766 8.17153 2.20792 8.02105 2.31024C7.87058 2.41257 7.75773 2.56133 7.69975 2.73382L7.23308 4.25882C7.16808 4.45172 7.03473 4.61416 6.85818 4.71548C6.68163 4.81681 6.4741 4.85001 6.27475 4.80882L4.66642 4.49215C4.50354 4.46913 4.3375 4.49483 4.18921 4.56602C4.04091 4.6372 3.917 4.75067 3.83308 4.89215L2.16642 7.77548C2.07572 7.92602 2.03494 8.10139 2.0499 8.2765C2.06487 8.45162 2.13482 8.61752 2.24975 8.75048L3.30808 9.95048C3.44168 10.1026 3.51536 10.2981 3.51536 10.5005C3.51536 10.7029 3.44168 10.8984 3.30808 11.0505L2.24975 12.2505C2.13482 12.3834 2.06487 12.5493 2.0499 12.7245C2.03494 12.8996 2.07572 13.0749 2.16642 13.2255L3.83308 16.1088C3.92067 16.2609 4.05402 16.3814 4.21413 16.4532C4.37424 16.5251 4.55294 16.5445 4.72475 16.5088L6.29142 16.1921C6.49077 16.151 6.6983 16.1842 6.87484 16.2855C7.05139 16.3868 7.18475 16.5492 7.24975 16.7421L7.75808 18.2671C7.81607 18.4396 7.92891 18.5884 8.07939 18.6907C8.22986 18.793 8.4097 18.8433 8.59142 18.8338H11.9248C12.0995 18.8343 12.2699 18.7798 12.4119 18.6781C12.554 18.5764 12.6605 18.4327 12.7164 18.2671L13.2248 16.7421C13.2898 16.5492 13.4231 16.3868 13.5997 16.2855C13.7762 16.1842 13.9837 16.151 14.1831 16.1921L15.7498 16.5088C15.9216 16.5445 16.1003 16.5251 16.2604 16.4532C16.4205 16.3814 16.5538 16.2609 16.6414 16.1088L18.3081 13.2255C18.3966 13.0732 18.4345 12.8969 18.4166 12.7217C18.3986 12.5466 18.3256 12.3816 18.2081 12.2505L17.0831 11.0505ZM15.8414 12.1671L16.5081 12.9171L15.4414 14.7671L14.4581 14.5671C13.8579 14.4445 13.2336 14.5464 12.7036 14.8537C12.1736 15.1609 11.7749 15.652 11.5831 16.2338L11.2664 17.1671H9.13308L8.83308 16.2171C8.6413 15.6354 8.24257 15.1442 7.71259 14.837C7.18261 14.5297 6.55827 14.4278 5.95808 14.5505L4.97475 14.7505L3.89142 12.9088L4.55808 12.1588C4.96805 11.7005 5.19469 11.1071 5.19469 10.4921C5.19469 9.87721 4.96805 9.28383 4.55808 8.82548L3.89142 8.07548L4.95808 6.24215L5.94142 6.44215C6.5416 6.56483 7.16594 6.46288 7.69592 6.15565C8.2259 5.84841 8.62463 5.35728 8.81642 4.77548L9.13308 3.83382H11.2664L11.5831 4.78382C11.7749 5.36561 12.1736 5.85675 12.7036 6.16398C13.2336 6.47122 13.8579 6.57317 14.4581 6.45048L15.4414 6.25048L16.5081 8.10048L15.8414 8.85048C15.4361 9.30778 15.2122 9.89772 15.2122 10.5088C15.2122 11.1199 15.4361 11.7098 15.8414 12.1671ZM10.1998 7.16715C9.54048 7.16715 8.89601 7.36265 8.34785 7.72892C7.79969 8.09519 7.37244 8.61578 7.12015 9.22487C6.86786 9.83396 6.80185 10.5042 6.93047 11.1508C7.05908 11.7974 7.37655 12.3913 7.84273 12.8575C8.3089 13.3237 8.90285 13.6411 9.54945 13.7698C10.1961 13.8984 10.8663 13.8324 11.4754 13.5801C12.0844 13.3278 12.605 12.9005 12.9713 12.3524C13.3376 11.8042 13.5331 11.1598 13.5331 10.5005C13.5331 9.61643 13.1819 8.76858 12.5568 8.14346C11.9317 7.51834 11.0838 7.16715 10.1998 7.16715ZM10.1998 12.1671C9.87012 12.1671 9.54788 12.0694 9.2738 11.8863C8.99972 11.7031 8.7861 11.4428 8.65995 11.1383C8.53381 10.8337 8.5008 10.4986 8.56511 10.1753C8.62942 9.85203 8.78815 9.55506 9.02124 9.32197C9.25433 9.08888 9.5513 8.93015 9.8746 8.86584C10.1979 8.80153 10.533 8.83454 10.8376 8.96068C11.1421 9.08683 11.4024 9.30045 11.5855 9.57453C11.7687 9.84861 11.8664 10.1708 11.8664 10.5005C11.8664 10.9425 11.6908 11.3664 11.3783 11.679C11.0657 11.9916 10.6418 12.1671 10.1998 12.1671Z"
        fill="#262626"
      />
    </svg>
  );
};

export const ArrowIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.5H11.5556M11.5556 6.5L6.55556 1.5M11.5556 6.5L6.55556 11.5"
        stroke="#262626"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StarIcon = ({
  className,
  size = 24,
}: {
  className: string;
  size: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_1291_50065)">
        <path
          d="M25.5 4L28.2365 22.7635L47 25.5L28.2365 28.2365L25.5 47L22.7635 28.2365L4 25.5L22.7635 22.7635L25.5 4Z"
          fill="url(#paint0_radial_1291_50065)"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_1291_50065"
          x="0"
          y="0"
          width="51"
          height="51"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.929412 0 0 0 0 0.827451 0 0 0 0 0.368627 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1291_50065"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1291_50065"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.929412 0 0 0 0 0.827451 0 0 0 0 0.368627 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1291_50065"
          />
        </filter>
        <radialGradient
          id="paint0_radial_1291_50065"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(25.5 25.5) rotate(90) scale(21.5)"
        >
          <stop stopColor="white" />
          <stop offset="0.432692" stopColor="#EDD35E" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.293 9.29297C14.6835 8.90244 15.3165 8.90244 15.707 9.29297C16.0976 9.68349 16.0976 10.3165 15.707 10.707L13.4141 13H21C21.5523 13 22 13.4477 22 14C22 14.5523 21.5523 15 21 15H13.4141L15.707 17.293C16.0976 17.6835 16.0976 18.3165 15.707 18.707C15.3165 19.0976 14.6835 19.0976 14.293 18.707L10.293 14.707C9.90244 14.3165 9.90244 13.6835 10.293 13.293L14.293 9.29297ZM9 3V5H15V3H9ZM18 3C18.7956 3 19.5585 3.3163 20.1211 3.87891C20.6837 4.44152 21 5.20435 21 6V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6C19 5.73478 18.8946 5.48051 18.707 5.29297C18.5195 5.10543 18.2652 5 18 5H17C17 6.10457 16.1046 7 15 7H9C7.89543 7 7 6.10457 7 5H6C5.73478 5 5.4805 5.10543 5.29297 5.29297C5.10543 5.4805 5 5.73478 5 6V20C5 20.2652 5.10543 20.5195 5.29297 20.707C5.48051 20.8946 5.73478 21 6 21H18C18.2652 21 18.5195 20.8946 18.707 20.707C18.8946 20.5195 19 20.2652 19 20V18C19 17.4477 19.4477 17 20 17C20.5523 17 21 17.4477 21 18V20C21 20.7957 20.6837 21.5585 20.1211 22.1211C19.5585 22.6837 18.7957 23 18 23H6C5.20435 23 4.44152 22.6837 3.87891 22.1211C3.3163 21.5585 3 20.7957 3 20V6C3 5.20435 3.3163 4.44152 3.87891 3.87891C4.44152 3.3163 5.20435 3 6 3H7C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3H18Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RefreshIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.33333 10.6667H12.6667V14M6.66667 5.33333H3.33333V2M12.945 6.00227C12.5712 5.07711 11.9454 4.27536 11.1387 3.68815C10.3319 3.10094 9.37678 2.75168 8.38151 2.68034C7.38624 2.609 6.39071 2.81827 5.50846 3.28441C4.62622 3.75055 3.89255 4.45503 3.39063 5.31742M3.05469 9.99805C3.42848 10.9232 4.05431 11.725 4.86105 12.3122C5.66779 12.8994 6.62392 13.2482 7.61919 13.3195C8.61445 13.3909 9.60917 13.1816 10.4914 12.7155C11.3737 12.2494 12.1068 11.545 12.6088 10.6826"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GreenCheckIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.5429 6.22857C11.8269 5.84986 11.7501 5.3126 11.3714 5.02857C10.9927 4.74454 10.4555 4.82129 10.1714 5.2L7.33583 8.98079L5.74895 7.39391C5.41421 7.05917 4.8715 7.05917 4.53677 7.39391C4.20203 7.72864 4.20203 8.27136 4.53677 8.60609L6.82248 10.8918C6.99818 11.0675 7.24148 11.1583 7.48933 11.1407C7.73719 11.1231 7.9652 10.9988 8.11429 10.8L11.5429 6.22857Z"
        fill="#36AB65"
      />
    </svg>
  );
};

export const RedErrorIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z M6.2 5L8 6.8L9.8 5L11 6.2L9.2 8L11 9.8L9.8 11L8 9.2L6.2 11L5 9.8L6.8 8L5 6.2L6.2 5Z"
        fill="#FF4D4F"
      />
    </svg>
  );
};

export const SmallArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.274587 12.8504C-0.0915291 12.4843 -0.0915292 11.8907 0.274587 11.5246L5.23667 6.5625L0.274587 1.60041C-0.0915296 1.2343 -0.0915297 0.640706 0.274587 0.27459C0.640703 -0.0915261 1.2343 -0.0915261 1.60041 0.27459L7.22541 5.89959C7.59153 6.2657 7.59153 6.8593 7.22541 7.22541L1.60041 12.8504C1.2343 13.2165 0.640704 13.2165 0.274587 12.8504Z"
        fill="white"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const SearchHistoryIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.3026 12.0377 14.0288 8.8484 14.445C8.43767 14.4986 8.06126 14.2091 8.00766 13.7984C7.95405 13.3877 8.24357 13.0113 8.6543 12.9577C11.1063 12.6377 13 10.5394 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 9.39838 3.57344 10.6626 4.5 11.5708V10.25C4.5 9.83579 4.83579 9.5 5.25 9.5C5.66421 9.5 6 9.83579 6 10.25V13.25C6 13.6642 5.66421 14 5.25 14H2.25C1.83579 14 1.5 13.6642 1.5 13.25C1.5 12.8358 1.83579 12.5 2.25 12.5H3.30964C2.1896 11.3327 1.5 9.74678 1.5 8ZM8 4.25C8.41421 4.25 8.75 4.58579 8.75 5V7.625L9.78333 8.4C10.1147 8.64853 10.1819 9.11863 9.93333 9.45C9.6848 9.78137 9.2147 9.84853 8.88333 9.6L7.55 8.6C7.36115 8.45836 7.25 8.23607 7.25 8V5C7.25 4.58579 7.58579 4.25 8 4.25Z"
        fill="white"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const LoaderLogo = () => {
  return (
    <svg
      width="290"
      height="276"
      viewBox="0 0 345 319"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 105.27V20.8433H45.5357V35.6865H27.1574V52.3261H34.3571C44.2094 52.3261 49.1356 57.9987 49.1356 69.3439V88.6307C49.1356 94.3033 48.0935 98.4632 45.9146 101.205C43.7358 103.852 39.6622 105.27 33.5993 105.27H12ZM27.1574 92.2233H29.9994C31.6099 92.2233 32.6519 91.8452 33.1256 90.9943C33.5993 90.1434 33.8835 89.0089 33.8835 87.3071V70.8566C33.8835 69.2494 33.5993 68.1148 33.1256 67.2639C32.6519 66.4131 31.6099 66.0349 29.9994 66.0349H27.1574V92.1288V92.2233Z"
        fill="white"
      />
      <path
        d="M92.1446 41.2645V85.9834C92.1446 92.2233 90.5341 97.2341 87.4079 100.921C84.1869 104.608 79.8292 106.499 74.2399 106.499H70.8295C64.8613 106.499 60.3141 104.703 57.1878 101.205C54.0616 97.7068 52.5459 92.6014 52.5459 85.9834V41.3591C52.5459 26.9885 58.6088 19.8032 70.7348 19.8032H74.1452C86.1763 19.8032 92.2393 26.9885 92.2393 41.2645H92.1446ZM76.324 86.4561V40.13C76.324 36.4428 74.9978 34.552 72.3452 34.552C69.6927 34.552 68.2717 36.4428 68.2717 40.13V86.4561C68.2717 89.7652 69.6927 91.4669 72.44 91.4669C74.9978 91.4669 76.324 89.7652 76.324 86.4561Z"
        fill="white"
      />
      <path
        d="M120.091 105.27V35.6864H114.313C114.313 63.7657 113.934 82.0125 113.27 90.3323C112.986 95.5322 111.66 99.3139 109.481 101.677C107.208 104.041 103.418 105.176 98.0183 105.176H94.229V89.8596H95.1763C96.6921 89.8596 97.7341 89.3868 98.2078 88.536C98.7762 87.6851 99.0604 86.1724 99.1551 84.187C99.7236 67.2638 99.913 46.0861 99.913 20.7485H135.154V105.176H119.997L120.091 105.27Z"
        fill="white"
      />
      <path
        d="M154.669 51.2861H161.869C171.721 51.2861 176.647 56.9587 176.647 68.3039V88.7252C176.647 94.3978 175.605 98.5577 173.426 101.299C171.247 103.947 167.174 105.365 161.111 105.365H139.606V20.8433H154.764V51.2861H154.669ZM154.669 92.2233H157.511C159.122 92.2233 160.164 91.8452 160.637 90.9943C161.111 90.1434 161.395 89.0089 161.395 87.3071V69.7221C161.395 68.1148 161.111 66.9803 160.637 66.1294C160.164 65.2785 159.122 64.9004 157.511 64.9004H154.669V92.1288V92.2233Z"
        fill="white"
      />
      <path
        d="M180.152 105.27V20.8433H195.31V90.0488H201.562V20.8433H216.72V90.0488H222.972V20.8433H238.129V105.27H180.247H180.152Z"
        fill="white"
      />
      <path
        d="M281.896 41.2645V85.9834C281.896 92.2233 280.286 97.2341 277.159 100.921C273.938 104.608 269.581 106.499 263.991 106.499H260.581C254.613 106.499 250.066 104.703 246.939 101.205C243.813 97.7068 242.297 92.6014 242.297 85.9834V41.3591C242.297 26.9885 248.36 19.8032 260.486 19.8032H263.897C275.928 19.8032 281.991 26.9885 281.991 41.2645H281.896ZM266.076 86.4561V40.13C266.076 36.4428 264.749 34.552 262.097 34.552C259.444 34.552 258.023 36.4428 258.023 40.13V86.4561C258.023 89.7652 259.444 91.4669 262.191 91.4669C264.749 91.4669 266.076 89.7652 266.076 86.4561Z"
        fill="white"
      />
      <path
        d="M310.222 105.27V60.4569L300.464 105.27H285.686V20.8433H300.464V66.0349L310.222 20.8433H325V105.27H310.222ZM305.674 18.2906H305.201C301.601 18.2906 298.759 17.2506 296.485 15.0761C294.212 12.9016 293.075 10.1599 293.075 6.56726V6H302.738V6.37817C302.738 8.36358 303.59 9.30901 305.39 9.30901H305.58C307.285 9.30901 308.232 8.36358 308.232 6.37817V6H317.8V6.56726C317.8 10.1599 316.663 12.9962 314.295 15.0761C311.927 17.1561 309.085 18.2906 305.769 18.2906H305.674Z"
        fill="white"
      />
      <path
        d="M68.3684 306.069L46.106 227.598V306.069H12.9492V120.765H46.106V192.05L67.8 120.765H100.483L74.2419 205.003L103.23 306.164H68.2737L68.3684 306.069Z"
        fill="white"
      />
      <path
        d="M186.407 160.567V265.226C186.407 278.557 183.565 289.146 177.786 297.087C172.007 305.029 161.871 309 147.187 309H140.461C127.009 309 117.251 304.935 111.093 296.898C105.031 288.862 101.999 278.557 101.999 266.172V233.554H134.966V265.226C134.966 272.695 137.714 276.477 143.208 276.477C148.703 276.477 151.734 272.79 151.734 265.226V227.126H127.009V192.239H151.734V160.567C151.734 153.382 148.987 149.884 143.492 149.884C137.998 149.884 134.966 153.476 134.966 160.567V185.432H101.999V159.244C101.999 153.476 102.567 148.277 103.609 143.833C104.652 139.389 106.546 135.04 109.199 130.975C111.851 126.91 115.83 123.79 121.04 121.615C126.251 119.441 132.693 118.401 140.366 118.401H147.092C160.734 118.401 170.681 122.277 176.933 130.124C183.186 137.971 186.312 148.087 186.312 160.473L186.407 160.567Z"
        fill="white"
      />
      <path
        d="M243.057 118.212H276.214V133.433H277.919C309.181 133.433 324.812 149.695 324.812 182.218V239.227C324.812 272.317 309.181 288.768 277.919 288.768H276.214V308.433H243.057V288.768H241.352C210.09 288.768 194.459 272.506 194.459 239.983V182.974C194.459 166.902 198.154 154.611 205.543 146.102C212.932 137.593 224.868 133.433 241.352 133.433H243.057V118.212ZM243.057 166.523H242.773C237.752 166.523 234.247 167.469 232.163 169.549C230.079 171.534 229.037 175.221 229.037 180.516V241.023C229.037 246.129 229.984 249.911 232.068 252.274C234.058 254.638 237.658 255.772 242.773 255.772H243.057V166.618V166.523ZM276.309 166.523V255.678H276.593C281.614 255.678 285.119 254.732 287.203 252.652C289.287 250.667 290.329 246.98 290.329 241.685V181.178C290.329 176.072 289.287 172.291 287.298 169.927C285.309 167.563 281.709 166.429 276.593 166.429H276.309V166.523Z"
        fill="white"
      />
    </svg>
  );
};
export const LoaderLogoDohod = () => {
  return (
    <svg
      width="106"
      height="97"
      viewBox="0 0 106 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.7915 45.4577C74.4065 45.3785 77.5901 45.763 79.3316 47.9499C81.6644 50.8808 81.4888 54.7708 81.4888 58.3014L81.4898 65.5426L81.4888 76.3844C81.4856 78.8617 81.5566 81.353 81.3198 83.8151L82.3706 83.8561C84.579 79.4093 84.5329 72.7513 84.7075 67.8102C84.9037 60.5091 84.9955 53.2054 84.9819 45.902L102.05 45.8942L102.051 82.318L102.044 83.8551C103.058 83.84 104.073 83.831 105.087 83.8278C105.028 88.087 105.043 92.7291 105.1 96.986C103.12 96.9286 100.875 96.9815 98.8736 96.9831L98.8638 90.653C95.1334 90.6689 90.8124 90.7738 87.1314 90.6422C87.172 92.7352 87.0858 94.8651 87.1177 96.9684C85.096 96.9294 82.902 96.9812 80.8716 96.9948C80.803 93.2984 80.8517 89.4848 80.8589 85.778C79.4971 89.0949 77.5633 90.9079 73.8257 91.1647C72.1761 91.2771 70.4324 91.2681 68.8267 90.8551C62.1803 89.1469 62.8483 81.4987 62.8491 76.1295L62.8501 66.5192L62.8423 59.2868C62.8375 54.8783 62.4757 48.9767 66.9849 46.4948C68.4909 45.666 70.1125 45.5365 71.7915 45.4577ZM73.1011 52.2077C72.6404 52.0142 72.1656 52.0183 71.6763 52.0622C71.0737 52.2527 70.491 52.5728 70.2573 53.1706C69.6325 54.7763 69.8304 57.344 69.8296 59.0319L69.8277 66.1491L69.8208 75.2702C69.8192 76.7444 69.827 78.2265 69.8198 79.6999C69.8095 81.7705 69.6805 84.9281 72.7466 84.5241C74.2526 83.9365 74.4522 82.9688 74.5112 81.4635C74.567 80.0405 74.5433 78.6098 74.5425 77.1852L74.5435 69.9518C74.5435 67.8406 74.7709 54.8061 74.2798 53.5241C74.0494 52.9231 73.7061 52.462 73.1011 52.2077ZM91.3784 52.4167C91.3721 58.36 91.3921 64.3162 91.0796 70.2516C90.85 74.6163 90.733 79.6755 89.2085 83.821C90.5751 83.8058 91.9398 83.8435 93.3071 83.8307C93.921 83.8235 94.6186 83.7986 95.2261 83.821L95.2114 52.4196C93.9471 52.4196 92.6388 52.4382 91.3784 52.4167Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.6875 45.8893C10.3384 45.9261 16.1671 45.7957 21.792 45.9245L21.7998 83.8376C22.8013 83.8224 23.8032 83.8228 24.8047 83.8395C24.8887 88.0304 24.8651 92.813 24.7949 97.0007C22.8364 96.905 20.542 96.9676 18.5654 96.9811L18.5713 92.5231L18.5693 90.6384C14.7459 90.6471 10.6181 90.7424 6.80664 90.6276C6.81836 92.7477 6.81489 94.8679 6.79688 96.988C4.96963 96.8915 2.42187 96.9578 0.571289 96.9929C0.586199 92.5963 0.576415 88.1988 0.541016 83.8014C1.06078 83.8421 1.57646 83.8289 2.09766 83.8249C4.42452 78.9802 4.35984 71.2652 4.48438 65.8249C4.61896 59.1808 4.68686 52.5351 4.6875 45.8893ZM11.084 52.402C11.0878 57.9093 11.0114 63.4167 10.8555 68.9216C10.7462 72.0374 10.5713 75.1197 10.2217 78.2204C10.0002 80.1851 9.48511 81.9462 8.92285 83.8288C10.2704 83.8352 11.7183 83.8008 13.0498 83.8327L14.9141 83.8512L14.9248 62.2868C14.9239 59.0345 14.8816 55.6754 14.9541 52.4343C13.7383 52.4295 12.2799 52.461 11.084 52.402Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.2386 45.4558C43.7641 45.1154 43.414 51.819 43.4115 60.1218L43.4076 69.3601L43.4095 77.153C43.4038 83.6993 43.5847 90.8258 35.0707 91.1989C32.4922 91.2499 29.7054 91.1315 27.6967 89.3112C24.1926 86.137 24.7731 80.2628 24.7758 75.9763V66.3103L24.7767 58.7888C24.7825 51.9754 24.8271 46.0326 33.2386 45.4558ZM36.1644 53.4157C35.9456 52.2994 34.5476 51.9624 33.5765 52.0525C32.1396 52.515 31.8087 53.6531 31.7611 55.0515C31.7149 56.4101 31.7425 57.7792 31.7445 59.1394L31.7425 66.3845L31.7386 75.7243C31.7386 77.0695 31.7226 78.422 31.7377 79.7663C31.7622 81.9669 31.5616 84.7658 34.6293 84.53C35.1834 84.3443 35.7757 84.0211 35.9886 83.4616C36.6826 81.6349 36.4731 78.7479 36.4691 76.8366L36.4662 69.8337L36.4681 61.196C36.4684 58.6725 36.6459 55.8723 36.1644 53.4157Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.5459 0.388493C61.1724 0.388892 62.9347 0.299483 64.5166 0.722478C65.7379 1.04906 66.763 1.6849 67.4072 2.80744C67.8713 3.61635 68.0961 4.5172 68.2236 5.43439C68.4748 7.24461 68.5104 14.2561 68.04 15.9168C67.6326 17.3559 66.7488 18.2368 65.4707 18.9412C70.2137 21.2776 68.5963 26.7147 68.8848 31.1111C69.0155 33.1034 68.8659 35.9656 68.1172 37.785C66.0872 41.8343 62.8445 41.2043 58.9082 41.2059L52.0039 41.2049C52.0955 40.427 52.0645 38.3549 52.0645 37.4969L52.0537 30.5223L52.0615 7.94513C52.0631 6.37363 52.0571 4.80163 52.042 3.23029C52.038 2.66241 51.9913 0.888764 52.1133 0.41486C54.5785 0.484308 57.0767 0.388018 59.5459 0.388493ZM62.4199 24.4031C62.2571 22.2754 59.8704 22.6229 58.2822 22.6278L58.2734 35.3875C59.4112 35.4147 61.038 35.6222 61.9189 34.8797C62.5631 34.0107 62.5231 32.5916 62.5127 31.5428C62.4888 29.1636 62.6009 26.7731 62.4199 24.4031ZM58.291 5.9549C58.283 9.34874 58.2097 13.124 58.2998 16.5018C59.4128 16.5262 60.7848 16.719 61.6172 15.9334C62.7014 14.3926 62.1873 9.52471 62.1514 7.53107C62.1171 5.69158 59.5157 5.99134 58.291 5.9549Z"
        fill="#FEFEFE"
      />
      <path
        d="M98.9894 0.382812C100.593 0.509512 103.534 0.411196 105.253 0.411754C105.151 5.4117 105.251 10.7441 105.251 15.7836L105.256 41.2081L98.9982 41.2089C98.9719 34.2286 98.877 26.6728 99.0181 19.7171C98.5326 21.2404 98.1323 23.8498 97.7775 25.5089C96.6996 30.7298 95.6487 35.9561 94.6242 41.1878C92.5392 41.2125 90.4534 41.2172 88.3677 41.2018C88.4506 35.7209 88.3804 30.052 88.3804 24.558L88.3525 0.394853C90.3793 0.447797 92.6054 0.400752 94.6473 0.400831C94.6146 6.87971 94.6194 13.3587 94.6616 19.8375L95.0228 20.0329C95.9278 15.8379 96.7889 11.6335 97.6053 7.42031C98.0558 5.18773 98.6418 2.60702 98.9894 0.382812Z"
        fill="#FEFEFE"
      />
      <path
        d="M94.6597 19.8359L95.0208 20.0314C94.8757 20.757 94.8829 21.5377 94.666 22.2324C94.6365 21.3968 94.6429 20.6684 94.6597 19.8359Z"
        fill="#CAB695"
      />
      <path
        d="M56.0746 45.8818C58.1053 45.978 60.7189 45.9102 62.7807 45.9116L58.9226 61.7431C58.6778 62.7629 57.6094 66.288 57.7752 67.0821C58.1532 68.8929 58.7679 71.265 59.2096 73.1013L63.4281 90.6359C62.52 90.6359 61.5808 90.6614 60.6695 90.6741C59.2526 90.6813 57.7673 90.7108 56.356 90.663C56.1886 89.3729 55.5133 86.5654 55.2167 85.1756C54.4847 81.747 53.8254 78.0345 52.973 74.6578C52.7195 76.337 52.1893 78.5696 51.8241 80.2751C51.0731 83.7284 50.3411 87.1865 49.6281 90.6486L42.7168 90.6821C44.051 84.9787 45.5563 79.2856 46.9153 73.5757C47.4082 71.505 48.2041 68.8092 48.4822 66.6898C48.5331 66.3023 48.024 64.2834 47.9055 63.7931C47.5101 62.1577 47.1059 60.5247 46.6926 58.8933C45.6298 54.5924 44.6612 50.1974 43.5487 45.9113C45.7663 45.8984 48.319 45.8448 50.5142 45.9464C51.5419 50.549 52.3216 55.2933 53.4036 59.9004C53.925 57.1232 54.4624 54.3484 55.0157 51.5776C55.3705 49.7995 55.8593 47.6443 56.0746 45.8818Z"
        fill="#FEFEFE"
      />
      <path
        d="M70.0894 0.386719C72.1624 0.442454 74.2386 0.338317 76.3419 0.426983C76.18 5.64389 76.3323 11.4647 76.306 16.7319L80.4679 16.7165C80.3571 11.3962 80.4648 5.74715 80.452 0.395888C82.5162 0.394771 84.6769 0.356736 86.73 0.444844L86.7491 41.2073L84.9767 41.2013L80.4664 41.2025L80.452 23.2835C79.079 23.2531 77.7037 23.2827 76.3148 23.2484L76.3108 41.209L70.0878 41.2177C70.1364 36.8415 70.0838 32.3694 70.083 27.9864L70.0894 0.386719Z"
        fill="#FEFEFE"
      />
      <path
        d="M6.18223 0.0845417C8.69742 -0.0835399 12.5049 -0.189747 14.3961 1.70301C16.6647 3.97354 16.4387 7.93877 16.4352 10.8965C16.4258 12.5423 16.4295 14.1879 16.4463 15.8336C14.4312 15.8111 12.3667 15.8367 10.3475 15.839C10.3317 14.1142 10.3253 12.3893 10.3281 10.6644C10.325 8.94845 10.7647 5.95608 8.27644 5.99084C6.8243 6.01109 6.48839 6.73222 6.41337 8.06698C6.32566 9.62628 6.34887 11.1854 6.34408 12.7447L6.34089 21.4638L6.33986 28.9313C6.33978 30.4774 6.30725 31.9964 6.42333 33.5474C6.43418 34.7019 7.18341 35.6772 8.4351 35.6663C10.742 35.6461 10.3503 31.8636 10.3474 30.4136L10.3335 25.3709C10.3322 24.7269 10.3211 24.083 10.3002 23.4393C12.3449 23.426 14.3897 23.4234 16.4344 23.4317C16.4252 25.7648 16.4279 28.098 16.4424 30.4311C16.4434 35.13 16.5544 40.7331 10.5315 41.6033C5.38564 42.3466 0.790355 41.0184 0.168774 35.2244C-0.05822 33.1086 0.0091522 31.0594 0.0099495 28.9171L0.0117841 19.5636L0.00436777 11.7556C0.00269342 10.6879 -0.00456208 9.61217 0.00436777 8.54539C0.0394493 4.33418 1.57825 0.588787 6.18223 0.0845417Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.207 0.390789C31.6313 0.290014 33.878 1.05353 33.9395 7.94743L33.9541 13.3205C33.9559 15.1198 34.0206 16.7945 33.8018 18.589C33.0472 24.7773 28.7994 24.2864 23.9766 24.2814C24.0008 26.6955 23.9769 29.1527 23.9766 31.5705C23.9778 34.7301 23.924 38.0472 23.9951 41.1935C21.9058 41.2096 19.816 41.2135 17.7266 41.2052C17.7769 33.7953 17.7827 26.3848 17.7441 18.9748C17.7714 12.9095 17.8725 6.43208 17.7188 0.382977C20.0633 0.459833 22.8638 0.427546 25.207 0.390789ZM23.9873 5.96012C23.9867 10.0746 24.0226 14.2628 23.9727 18.3732C24.9569 18.38 26.418 18.5568 27.1348 17.8019C27.3561 17.4151 27.4727 17.0602 27.5342 16.6213C27.7182 15.3062 27.7575 8.40769 27.4453 7.29606C27.3137 6.82818 27.1607 6.49778 26.7168 6.26774C25.969 5.88048 24.8169 5.98069 23.9873 5.96012Z"
        fill="#FEFEFE"
      />
      <path
        d="M46.3789 0.385742C46.4208 1.74746 46.7938 4.05759 46.9736 5.49219L48.3877 16.2393C49.5096 24.54 50.4554 32.9071 51.6582 41.1953L45.5742 41.2041C45.416 39.2107 45.2156 37.2206 44.9746 35.2354C44.9076 34.6686 44.8459 34.1011 44.7891 33.5332C43.2853 33.5424 41.7811 33.5413 40.2773 33.5293C40.1446 34.3693 40.0711 35.6552 39.9932 36.5293L39.5361 41.2246C37.7137 41.1667 35.759 41.209 33.9287 41.2197C34.3503 38.7251 34.6652 35.436 34.9512 32.9043L36.1738 22.9141L37.8066 9.60449C38.1763 6.65405 38.6576 3.32339 38.8984 0.386719C41.1542 0.485344 44.0774 0.40448 46.3789 0.385742ZM42.415 13.7734C41.993 18.2772 41.4082 22.8747 40.9746 27.4062C42.0223 27.4394 43.071 27.4506 44.1191 27.4395C44.0093 25.7875 43.7822 23.9881 43.5869 22.3301C43.2582 19.5396 43.0234 16.6993 42.6943 13.918L42.415 13.7734Z"
        fill="#FEFEFE"
      />
      <path
        d="M42.4182 13.7684C42.4209 13.5219 42.3923 13.1986 42.5101 13.001C42.6634 13.2536 42.6657 13.6086 42.6977 13.9127L42.4182 13.7684Z"
        fill="#CAB695"
      />
    </svg>
  );
};

export const OrdersIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.875 13.0262V6.84369L14.375 7.73655V10.3125C14.375 10.8302 13.9553 11.25 13.4375 11.25C12.9197 11.25 12.5 10.8302 12.5 10.3125V8.40619L9.6875 9.41065V17.0209L15.6584 14.7818C16.3902 14.5074 16.875 13.8078 16.875 13.0262ZM14.0573 5.85903L16.0579 5.14451C15.9884 5.09702 15.9152 5.05387 15.8385 5.01556L11.8741 3.03334C11.4078 2.80017 10.8654 2.77171 10.3772 2.95477L9.20075 3.39595L13.8568 5.72395C13.9302 5.76067 13.9974 5.80625 14.0573 5.85903ZM6.80496 4.29437L11.6522 6.71798L8.81144 7.73254L4.05488 5.35426C4.1454 5.30146 4.2412 5.25578 4.34165 5.21811L6.80496 4.29437ZM7.8125 9.32939L3.125 6.98564V13.3074C3.125 14.0176 3.52625 14.6668 4.16147 14.9844L7.8125 16.8099V9.32939ZM1.25 6.97373C1.25 6.429 1.36775 5.90418 1.58313 5.42831C1.59939 5.35277 1.62532 5.27802 1.66147 5.20572C1.70686 5.11495 1.76497 5.03477 1.83258 4.96624C2.26001 4.29198 2.9011 3.75581 3.68329 3.4625L9.71886 1.19916C10.6952 0.833019 11.78 0.889953 12.7126 1.35629L16.6771 3.3385C17.9475 3.97372 18.75 5.27221 18.75 6.69261V13.0262C18.75 14.5894 17.7804 15.9886 16.3167 16.5375L10.2811 18.8008C9.30478 19.1669 8.22005 19.11 7.28738 18.6437L3.32295 16.6615C2.05251 16.0262 1.25 14.7277 1.25 13.3074V6.97373Z"
        fill="#DD6DF6"
      />
    </svg>
  );
};

export const CreditCardIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.625 5H4.375C3.33947 5 2.5 5.83947 2.5 6.875L17.5 6.875C17.5 5.83947 16.6605 5 15.625 5ZM2.5 13.125V8.75H17.5V13.125C17.5 14.1605 16.6605 15 15.625 15H4.375C3.33947 15 2.5 14.1605 2.5 13.125ZM4.375 3.125C2.30393 3.125 0.625 4.80393 0.625 6.875V13.125C0.625 15.1961 2.30393 16.875 4.375 16.875H15.625C17.6961 16.875 19.375 15.1961 19.375 13.125V6.875C19.375 4.80393 17.6961 3.125 15.625 3.125H4.375ZM5.3125 11.25C4.79473 11.25 4.375 11.6697 4.375 12.1875C4.375 12.7053 4.79473 13.125 5.3125 13.125H8.4375C8.95527 13.125 9.375 12.7053 9.375 12.1875C9.375 11.6697 8.95527 11.25 8.4375 11.25H5.3125Z"
        fill="#DD6DF6"
      />
    </svg>
  );
};

export const AddCreditCardIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 15.6667V17.5H5V15.6667H16.25ZM18.125 13.8333V7.41667C18.125 6.40414 17.2855 5.58333 16.25 5.58333H5C3.96447 5.58333 3.125 6.40415 3.125 7.41667V13.8333C3.125 14.8459 3.96447 15.6667 5 15.6667V17.5L4.80682 17.4955C2.82552 17.3972 1.25 15.795 1.25 13.8333V7.41667C1.25 5.39162 2.92893 3.75 5 3.75H16.25C18.3211 3.75 20 5.39162 20 7.41667V13.8333C20 15.8584 18.3211 17.5 16.25 17.5V15.6667C17.2855 15.6667 18.125 14.8459 18.125 13.8333Z"
        fill="#DD6DF6"
      />
      <path
        d="M9.6875 13.6042V11.5408L7.57812 11.5417C7.18989 11.5417 6.87511 11.2338 6.875 10.8542C6.875 10.4746 7.18986 10.1668 7.57812 10.1667L9.6875 10.1658V8.10417C9.6875 7.72447 10.0023 7.41667 10.3906 7.41667C10.779 7.41667 11.0938 7.72447 11.0938 8.10417V10.1649H13.2031C13.5913 10.1649 13.9061 10.4728 13.9062 10.8524C13.9064 11.2321 13.5915 11.5398 13.2031 11.5399H11.0938V13.6042C11.0938 13.9839 10.7789 14.2917 10.3906 14.2917C10.0023 14.2917 9.6875 13.9839 9.6875 13.6042Z"
        fill="#DD6DF6"
      />
    </svg>
  );
};

export const CheckMarkIcon = () => {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 5.71818L6.18627 9.5L13.5 1.5"
        stroke="#F5F5F5"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const TrashBinIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4999 3H10.4999C10.0857 3 9.74993 3.33579 9.74993 3.75V4.5H14.2499V3.75C14.2499 3.33579 13.9141 3 13.4999 3ZM16.4999 4.5V3.75C16.4999 2.09315 15.1568 0.75 13.4999 0.75H10.4999C8.84308 0.75 7.49993 2.09315 7.49993 3.75V4.5H6.00176H3.7498H3.375C2.75368 4.5 2.25 5.00368 2.25 5.625C2.25 6.24632 2.75368 6.75 3.375 6.75H3.84355L4.32011 18.1873C4.42054 20.5977 6.4038 22.5 8.81621 22.5H15.1834C17.5958 22.5 19.5791 20.5977 19.6795 18.1873L20.1561 6.75H20.6249C21.2463 6.75 21.7499 6.24632 21.7499 5.625C21.7499 5.00368 21.2463 4.5 20.6249 4.5H20.2498H17.9979H16.4999ZM17.9041 6.75H16.4999H14.2499H9.74993H7.49993H6.09551L6.56816 18.0937C6.61837 19.2988 7.61 20.25 8.81621 20.25H15.1834C16.3896 20.25 17.3812 19.2988 17.4314 18.0937L17.9041 6.75ZM8.62463 9.75V17.25C8.62463 17.8713 9.12831 18.375 9.74963 18.375C10.371 18.375 10.8746 17.8713 10.8746 17.25V9.75C10.8746 9.12868 10.371 8.625 9.74963 8.625C9.12831 8.625 8.62463 9.12868 8.62463 9.75ZM14.2496 8.625C14.871 8.625 15.3746 9.12868 15.3746 9.75V17.25C15.3746 17.8713 14.871 18.375 14.2496 18.375C13.6283 18.375 13.1246 17.8713 13.1246 17.25V9.75C13.1246 9.12868 13.6283 8.625 14.2496 8.625Z"
        fill="#FF4433"
      />
    </svg>
  );
};

export const RatingStarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#F59E0B"
      stroke="#F59E0B"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
    </svg>
  );
};
